export interface WorkerStatute {
   id: number;
   name: {
      [key: string]: string;
   };
   created_at: Date;
   updated_at: Date;
   deleted_at?: Date;
   key: WorkerStatuteKey;
   dimona_code: WorkerStatuteKey;
}

export enum WorkerStatuteKey {
   ARB = 'ARB',
   BED = 'BED',
   JOBARB = 'J ARB',
   JOBBED = 'J BED',
   WERKARB = 'W ARB',
   WERKBED = 'W BED',
   OTHER = 'OTHER',
}
